import { render } from "./TableCellRouterLink.vue?vue&type=template&id=1c94c86f&scoped=true"
import script from "./TableCellRouterLink.vue?vue&type=script&lang=js"
export * from "./TableCellRouterLink.vue?vue&type=script&lang=js"

import "./TableCellRouterLink.vue?vue&type=style&index=0&id=1c94c86f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c94c86f"]])

export default __exports__